export default () => {

    $(document).on('scroll', () => {
        stickyMenu();
    })

    let $menuOverlay = $('#js-full-screen-menu');

    $menuOverlay.on('open', () => {
        $( '.header__toggle-mm' ).addClass( 'header__toggle-mm--open' );
    });

    $menuOverlay.on('close', () => {
        $( '.header__toggle-mm' ).removeClass( 'header__toggle-mm--open' );
    });
};

function stickyMenu()
{
    if ($(document).scrollTop() > 5 ) {
        $( '.header' ).addClass( 'header--sticky' );
        $( '.progress-section' ).addClass( 'progress-section--sticky' );
    } else {
        $( '.header' ).removeClass( 'header--sticky' );
        $( '.progress-section' ).removeClass( 'progress-section--sticky' );
    }
}
